export const HierarchyActionTypes = {
    CollapseAll: 'APP_COLLAPSE_ALL',
    HierarchySearch: 'APP_FILTER_HIERARCHY',
    SelectWell: 'APP_SELECT_WELL',
    SelectWells: 'APP_SELECT_WELLS',
    UnselectWell: 'APP_UNSELECT_WELL',
    UnselectWells: 'APP_UNSELECT_WELLS',
};